/* global Stickyfill */

Stickyfill.addOne($('#header-container'));
